module.exports = __webpack_public_path__ + "img/bg-pop-up-dark.519684b5.png";